import { render } from "./AccountEditPage.vue?vue&type=template&id=fd57023a&scoped=true"
import script from "./AccountEditPage.vue?vue&type=script&lang=js"
export * from "./AccountEditPage.vue?vue&type=script&lang=js"

import "./AccountEditPage.vue?vue&type=style&index=0&id=fd57023a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd57023a"]])

export default __exports__